import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "../../styles/color.styles";
import spacing from "../../styles/spacing.styles";
import { size } from "../../styles/type.styles";

const chipFocused: CSSProperties = {
  backgroundColor: greys.cloudyBlue,
};

const chip: CSSProperties = {
  backgroundColor: greys.white,
  border: `1px solid ${greys.borderGrey}`,
  borderRadius: `20px`,
  height: 38,
  margin: spacing.xs,
  // Content
  color: greys.slate,
  fontSize: size.md,
};

const avatar: CSSProperties = {
  color: `${greys.white} !important`,
  backgroundColor: colors.blueCool.standard,
};

export const styles = {
  avatar,
  chip,
  chipFocused,
};
